module.exports = __webpack_public_path__ + "static/download/배민스토리2022.pdf";